module.exports = __webpack_public_path__ + "static/img/Dan_Hannebery_desktop.b7c491a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dan_Hannebery_desktop.jpg
// module id = X/ZB
// module chunks = 0